import TablePage from '@/found/components/table_page';
import Form from './form';

export default {
  name: 'channelPoolDetails',
  extends: TablePage,
  data() {
    return {};
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('mainList');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add' || val.code === 'edit' || val.code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        console.log(this.modalConfig);
        this.modalConfig.width = '500px';
        this.modalConfig.title = val.name || '查看';
        this.openModal();
      }
    },
  },
};
